import colors from "./Colors";

export const tokens = {
  Primary: {
    Primary200: colors.Turquoise.Turquoise200,
    Primary400: colors.Turquoise.Turquoise400
  },
  Text: {
    General: {
      PrimaryHeadline: colors.Neutral.Neutral900,
      PrimaryBody: colors.Neutral.Neutral900,
      Secondary: colors.Neutral.Neutral600,
      Tertiary: colors.Neutral.Neutral400,
      Inverse: colors.Neutral.Neutral0,
      Color: colors.Turquoise.Turquoise500
    },
    Feedback: {
      Progress: colors.Turquoise.Turquoise500,
      ProgressLight: colors.Teal.Teal400,
      ProgressDark: colors.Turquoise.Turquoise700,
      Done: colors.Green.Green500,
      Overdue: colors.Orange.Orange600,
      OverdueLight: colors.Orange.Orange400,
      OverdueDark: colors.Orange.Orange800,
      Alert: colors.Red.Red500,
      Warning: colors.Yellow.Yellow700,
      Neutral: colors.Neutral.Neutral900,
      Success: colors.Green.Green500,
      SuccessDark: colors.Teal.Teal700
    }
  },
  Draggable: {
    General: {
      Background: colors.Neutral.Neutral200,
      Border: colors.Neutral.Neutral300,
      Text: colors.Neutral.Neutral900,
      DraggedItem: colors.Blue.Blue50,
      DraggedText: colors.Turquoise.Turquoise500
    }
  },
  Background: {
    General: {
      Primary: colors.Neutral.Neutral0,
      Secondary: colors.Neutral.Neutral100,
      Tertiary: colors.Neutral.Neutral200,
      Color: colors.Blue.Blue50,
      LightColor: colors.Blue.Blue500
    },
    Feedback: {
      Alert: colors.Red.Red100,
      Warning: colors.Yellow.Yellow100,
      Success: colors.Green.Green50,
      Info: colors.Neutral.Neutral100,
      SuccessDark: colors.Green.Green100,
      Overdue: colors.Orange.Orange100
    }
  },
  Border: {
    General: {
      Primary: colors.Neutral.Neutral600,
      Secondary: colors.Neutral.Neutral400,
      Tertiary: colors.Neutral.Neutral100,
      Inverse: colors.Neutral.Neutral0,
      Color: colors.Turquoise.Turquoise500,
      LightColor: colors.Turquoise.Turquoise300
    },
    Feedback: {
      Alert: colors.Red.Red500,
      LightAlert: colors.Red.Red300,
      Success: colors.Teal.Teal200,
      Warning: colors.Yellow.Yellow400
    }
  },
  Icon: {
    General: {
      Primary: colors.Neutral.Neutral900,
      Secondary: colors.Neutral.Neutral600,
      Tertiary: colors.Neutral.Neutral400,
      Inverse: colors.Neutral.Neutral0,
      Color: colors.Turquoise.Turquoise500
    },
    Feeback: {
      Alert: colors.Red.Red500,
      Warning: colors.Yellow.Yellow700,
      Success: colors.Green.Green500,
      Progress: colors.Turquoise.Turquoise500,
      Overdue: colors.Orange.Orange600
    }
  },
  BoxShadow: `0px 0px 1px ${colors.Shadow.Shadow0}, 0px 2px 4px ${colors.Shadow.Shadow10}`
};
